<ftr-form-input
  name="password"
  [type]="type"
  [label]="label"
  [autofocus]="autofocus"
  [ngFormControl]="ngFormControl"
  [required]="true"
  [highlightError]="highlightError"
  [notrack]="true"
  [hideValidationErrors]="hideValidationErrors"
  [autocomplete]="autocomplete"
/>
<button
  type="button"
  (click)="toggleVisibility()"
  class="password__visibility"
  [ngClass]="{
    'password__visibility--hidden': type === 'password',
    'password__visibility--visible': type === 'text',
  }"
>
  <ftr-icon class="password__make-visible" icon="VisibilityOn" align="Bottom" label="Make password visible" />
  <ftr-icon class="password__make-invisible" icon="VisibilityOff" align="Bottom" label="Make password invisible" />
</button>
